import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import ProblemSolution from './components/ProblemSolution';
import ServicePackages from './components/ServicePackages';
import GooglePartner from './components/GooglePartner';
import CaseStudy from './components/CaseStudy';
import Transformations from './components/Transformations';
import AboutUs from './components/AboutUs';
import Team from './components/Team';
import Blog from './components/Blog';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import CookieConsent from './components/CookieConsent';
import PageLoader from './components/PageLoader';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import NotFound from './pages/NotFound';

const LandingPage = () => {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <ProblemSolution />
        <ServicePackages />
        <GooglePartner />
        <CaseStudy />
        <Transformations />
        <AboutUs />
        <Team />
        <Blog />
        <FAQ />
        <Footer />
      </main>
      <WhatsAppButton />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PageLoader />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <CookieConsent />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
